import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { Question } from '@/utils/types';

export const questionsApi = createApi({
	reducerPath: 'questionsApi',
	tagTypes: ['questions'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		addQuestion: builder.mutation({
			query: (body: Question) => ({
				url: `survey-questions`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['questions'],
		}),
		getQuestionById: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `survey-questions/${id}`,
			}),
		}),
		updateQuestion: builder.mutation({
			query: ({ body, id }: { body: Question; id: string }) => ({
				url: `survey-questions/${id}`,
				method: 'PATCH',
				body,
			}),
			invalidatesTags: ['questions'],
		}),
		deleteQuestion: builder.mutation({
			query: (id: string) => ({
				url: `survey-questions/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['questions'],
		}),
	}),
});

export const { useGetQuestionByIdQuery, useAddQuestionMutation, useDeleteQuestionMutation, useUpdateQuestionMutation } =
	questionsApi;
